

import {NavLink} from "react-router-dom";
import {useState} from "react";

const Index = (props) => {

    const [fName , setFName] = useState('');
    const [lName , setLName] = useState('');
    const [userName , setUserName] = useState('');
    const [password , setPassword] = useState('');
    const submit = () => {
        props.ajax(window.config.api+'/register' , {
            fName:fName,
            lName:lName,
            username:userName,
            password:password,
        }).then(function (res) {

            if(res && res.status === 'success'){
                localStorage.setItem('auth-ex' , res.authToken)
                props.setAuth(res.authToken)
            }
            else{
                if(res && res.status === 'error'){
                    props.ctx._notif(res.status,res.message)
                }else{
                    props.ctx._notif('error','error happen')

                }

            }


        })
    }

    return (<div
        className="col-12  min-h-lg-screen d-flex flex-column py-lg-16 px-lg-20 position-relative">
        <div className="card auth-card d-flex align-items-center">
            <div className="card-body">
                <div className="ng-tns-c39-1 ng-star-inserted">
                    <div className="row ng-tns-c39-1">
                        <div
                            className="col-12 col-lg-10 col-md-10 col-xl-10 mx-auto ng-tns-c39-1">
                            <div className="text-center mb-9 ng-tns-c39-1"><NavLink to={'/'}
                                                                                    className="navbar-brand-2 ng-tns-c39-1"><img
                                src={props.logo} alt="logo"
                                className="ng-tns-c39-1"/> </NavLink></div>
                            <div className="text-center mb-8 ng-tns-c39-1"><h1
                                className="h4 ls-tight mt-6 text-muted ng-tns-c39-1">
                                ثبت نام </h1><p
                                className="mt-2 text-muted text-sm opacity-70 ng-tns-c39-1">مارکت
                                رسمی خرید و فروش ارز دیجیتال</p></div>
                            <div className="ng-tns-c39-1 ng-pristine ng-invalid ng-touched">
                                <div className="mb-5 ng-tns-c39-1"><label
                                    htmlFor="nameAdd"
                                    className="form-label ng-tns-c39-1">نام</label>

                                    <input
                                        type="text" dir="ltr"  autoFocus=""
                                        autoComplete="off"
                                        id={'nameAdd'}
                                        value={fName}
                                        onChange={event => {
                                            setFName(event.target.value)
                                        }}
                                        className="form-control en ng-tns-c39-1 ng-pristine ng-invalid "/>

                                </div>
                                <div className="mb-5 ng-tns-c39-1"><label
                                    className="form-label ng-tns-c39-1">نام خانوادگی</label>

                                    <input
                                        type="text" dir="ltr" autoFocus=""
                                        autoComplete="off"
                                        value={lName}
                                        onChange={event => {
                                            setLName(event.target.value)
                                        }}
                                        className="form-control en ng-tns-c39-1 ng-pristine ng-invalid "/>

                                </div>

                                <div className="mb-5 ng-tns-c39-1"><label
                                    className="form-label ng-tns-c39-1">آدرس ایمیل</label>

                                    <input
                                        type="email" dir="ltr"   autoFocus=""
                                        autoComplete="off"
                                        value={userName}
                                        onChange={event => {
                                            setUserName(event.target.value)
                                        }}
                                        className="form-control en ng-tns-c39-1 ng-pristine ng-invalid "/>

                                </div>

                                <div className="mb-5 ng-tns-c39-1"><label
                                    className="form-label ng-tns-c39-1">رمز عبور</label>

                                    <input
                                        type="password" dir="ltr"   autoFocus=""
                                        autoComplete="off"
                                        value={password}
                                        onChange={event => {
                                            setPassword(event.target.value)
                                        }}
                                        className="form-control en ng-tns-c39-1 ng-pristine ng-invalid "/>

                                </div>


                                <div className="ng-tns-c39-1"><a
                                    type="button"
                                    onClick={submit}
                                    className="btn btn-primary btn-lg w-full ng-tns-c39-1">
                                  ثبت نام
                                </a></div>
                            </div>

                            <div className="my-6 text-center ng-tns-c39-1"><small
                                className="ng-tns-c39-1">
                                ورود به پنل کاربری
                            </small><NavLink
                                className="text-primary text-sm font-semibold me-2 ng-tns-c39-1"
                                to={window.config.staticAddress + "/auth/login"}>ورود</NavLink>
                            </div>

                            <div className="my-6 text-center ng-tns-c39-1"><small
                                className="ng-tns-c39-1">کلمه عبور خود را فراموش کرده
                                اید؟</small><NavLink
                                className="text-primary text-sm font-semibold me-2 ng-tns-c39-1"
                                to={window.config.staticAddress + "/auth/forgotPassword"}>بازیابی کلمه عبور</NavLink>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>)
}
export default Index;
